import { render, staticRenderFns } from "./ProfileGroupAddForm.vue?vue&type=template&id=13b12164"
import script from "./ProfileGroupAddForm.vue?vue&type=script&lang=js"
export * from "./ProfileGroupAddForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports